import React from 'react';
import { useMediaQuery as useEcoMediaQuery } from "@bsw/react-nightingale";

export const useMediaQuery = (props) => {
    return useEcoMediaQuery(props)
}